<app-banner
  [user]="null"
  [title]="'printerHeader' | translate"
  [isWebApps]="isWebApps"
>
</app-banner>

<div class="capture-container">
  <app-capture
    parentType="printer"
    (restartFilingEvent)="redirectBack()"
  ></app-capture>
</div>

<p-toast
  position="bottom-right"
  key="errorToast"
  class="error-toast"
>
  <ng-template
    let-message
    pTemplate="message"
  >
    <div class="toast-message-container">
      <div class="icon-container">
        <i class="fa-solid fa-circle-exclamation"></i>
      </div>
      <div class="message-container">
        <span class="message-summary">{{ message.summary | translate }}</span>
        <span>{{ message.detail | translate }}</span>
        @if (message.data) {
          <span>{{ message.data }}</span>
        }
      </div>
    </div>
  </ng-template>
</p-toast>

<p-confirmDialog
  #deletePrinterFileConfirmDialog
  key="deleteAdHocFileConfirmDialog"
  [header]="'warning' | translate"
>
  <ng-template
    let-message
    pTemplate="message"
  >
    <div class="delete-confirm-container">
      <div class="">
        <p>{{ 'deleteDocumentMessage' | translate }}</p>
        <p>{{ 'confirmDeleteDocument' | translate }}</p>
      </div>
    </div>
  </ng-template>
  <ng-template
    let-footer
    pTemplate="footer"
  >
    <div class="delete-confirm-buttons-container">
      <p-button
        class="dap-cancel-btn cancel-button"
        variant="text"
        [label]="'cancel' | translate"
        (click)="deletePrinterFileConfirmDialog.onReject()"
      >
      </p-button>

      <p-button
        class="dap-confirm-delete-btn confirm-button"
        severity="danger"
        variant="outlined"
        [label]="'deleteDocument' | translate"
        (click)="deletePrinterFileConfirmDialog.onAccept()"
      >
      </p-button>
    </div>
  </ng-template>
</p-confirmDialog>
